import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const realTimeInventoryBundleUrl = "/api/sainc/owningCompaniesRealTimeInventory/bundle";
const realTimeInventorySingleUrl = "/api/sainc/owningCompaniesRealTimeInventory/product";

export interface RealTimeInventoryModel {
    components?: BundleElement[];
    bundleErpNumber?: string;
    productNumber?: string;
    successful?: boolean;
    result?: any;
    errorMessage?: any;
}
export interface BundleElement {
    erpNumber: string;
    qtyPer: number;
}

export interface RealTimeInventoryParameter extends ApiParameter {
    inventory?: Partial<RealTimeInventoryModel>;
}

export async function getInventoryForBundleProduct(
    parameter: RealTimeInventoryParameter,
): Promise<ServiceResult<RealTimeInventoryModel>> {
    try {
        const inventory = await post<RealTimeInventoryModel>(
            `${realTimeInventoryBundleUrl}`,
            parameter.inventory as RealTimeInventoryModel,
        );
        return {
            result: inventory,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}

export async function getInventoryForSingleProduct(
    parameter: RealTimeInventoryParameter,
): Promise<ServiceResult<RealTimeInventoryModel>> {
    try {
        const inventory = await post<RealTimeInventoryModel>(
            `${realTimeInventorySingleUrl}`,
            parameter.inventory as RealTimeInventoryModel,
        );
        return {
            result: inventory,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
